var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShield = function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.496 21.5c.142 0 .374-.053.606-.178 5.061-2.843 6.808-4.046 6.808-7.298V7.207c0-.936-.41-1.23-1.159-1.55-1.051-.437-4.455-1.658-5.507-2.023-.24-.08-.49-.134-.748-.134-.25 0-.5.071-.74.134-1.051.32-4.455 1.595-5.507 2.022-.748.312-1.158.615-1.158 1.55v6.818c0 3.252 1.755 4.446 6.808 7.298.231.125.454.178.597.178Zm0-1.622V4.926c.107 0 .214.026.356.08 1.373.49 3.957 1.48 5.338 1.951.24.09.303.214.303.517v6.22c0 2.745-1.328 3.466-5.436 5.97-.267.16-.419.214-.561.214Z",
    fill: "#004152"
  })));
};
export default SvgShield;